import {
  Status,
  StatusIndicator,
  StatusLabel,
} from "@thilke/ui/components/ui/status";
import { cn } from "@thilke/ui/lib/utils";
import type * as React from "react";

function StatusPageBlock({
  className,
  ...props
}: React.ComponentProps<"section">) {
  return (
    <section
      data-slot="status-page-block"
      className={cn(
        "grid gap-3 rounded-lg border bg-background p-4",
        className,
      )}
      {...props}
    >
      <div className="flex items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold">Service health</h3>
          <p className="text-sm text-muted-foreground">
            Service health and incident summaries.
          </p>
        </div>
        <Status variant="success">
          <StatusIndicator />
          <StatusLabel>operational</StatusLabel>
        </Status>
      </div>
      <div className="grid gap-2">
        {["Registry", "Pages deploy", "Worker API"].map((service) => (
          <div
            key={service}
            className="flex items-center justify-between rounded-md border bg-card px-3 py-2 text-sm"
          >
            <span>{service}</span>
            <Status variant="success">
              <StatusIndicator />
              <StatusLabel>ok</StatusLabel>
            </Status>
          </div>
        ))}
      </div>
    </section>
  );
}

export { StatusPageBlock };
